import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";

import { WishlistsStateKitQueryWrapper } from "./WishlistsStateKitQueryWrapper";
import { WishlistsStateKitServiceWrapper } from "./WishlistsStateKitServiceWrapper";

export class WishlistsStateKit {
    public readonly query: WishlistsStateKitQueryWrapper;
    public readonly service: WishlistsStateKitServiceWrapper;

    constructor(
        wishlistsQuery: WishlistsQuery,
        wishlistsService: WishlistsService
    ) {
        this.query = new WishlistsStateKitQueryWrapper(wishlistsQuery);
        this.service = new WishlistsStateKitServiceWrapper(
            wishlistsService,
            wishlistsQuery
        );
    }
}
